<template>
  <div class="datepicker-desktop" ref="calendarWrap">
    <div v-if="withInput" class="placeholder-container" :class="{'error': errorInput}">
      <input type="text"
        placeholder=" "
        name="datepicker"
        id="datepicker"
        class="mainInp calendarInp"
        :class="{'acceptInp': acceptInput}"
        :value="formattedValue"
        @input="onInput(parseDate($event))"
        @focus="onFocus()"
        readonly />
      <label for="datepicker">{{ placeholder }}</label>
      <BaseInputError :error="errorInput">
        <slot name="empty-input-error" v-if="!formattedValue">
          {{ $t('qic_error_empty_input') }}
        </slot>
        <slot class="error" name="invalid-input-error" v-if="value_">
          {{ $t('qic_error_invalid_input') }}
        </slot>
      </BaseInputError>
    </div>
    <div class="dobPicker"
      v-show="show">
      <div class="dobPicker_calendar">
        <header class="select-dob">
          <div class="inpDobGroup">
            <div class="placeholder-container ">
              <input type="text"
                readonly
                name="month"
                :value="getMonthName(currentMonth.month)"
                @blur="toggleMonth(false)"
                @click="onMonthInputClick"
                class="mainInp" />
              <label for="month">{{ $t('qic_month') }}</label>
              <div class="selectDob" v-show="showMonthOptions">
                  <div class="overflowww">
                    <div v-for="mon in 12" :key="mon" @mousedown="selectMonth(mon - 1)">
                      {{ getMonthName(mon - 1) }}
                    </div>
                  </div>
              </div>
            </div>

            <div class="placeholder-container dobDay">
              <input type="text"
                ref="yearInput"
                readonly
                :value="currentMonth.year"
                name="year"
                @blur="toggleYear(false)"
                @click="onYearInputClick"
                class="mainInp">
              <label for="year">{{ $t('qic_year') }}</label>
              <div class="selectDob" v-show="showYearOptions">
                  <div class="overflowww" ref="yearList">
                    <div v-for="(year) of yearsList" :key="year" @mousedown="selectYear(year)">
                      {{ year }}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </header>
        <date-picker
          class="dobPicker_day"
          :value="value_"
          @input="onInput"
          mode="date"
          is-required
          trim-weeks
          :first-day-of-week="1"
          @dayclick="onDayClick"
          @update:to-page="onUpdateToPage"
          :step="1"
          :locale="locale"
          :min-date="minDate"
          :max-date="maxDate"
          :masks="masks"
          :columns="1"
          :rows="1"
          :is-expanded="true"
          ref="calendar">
          <template v-slot:header="page">
            <div v-show="false" class="vc-title">{{ page.monthLabel }} {{ page.yearLabel }}</div>
          </template>
          <template v-slot:header-left-button>
            <div v-show="false" class="prevMonth"></div>
          </template>
          <template v-slot:header-right-button>
            <div v-show="false" class="nextMonth"></div>
          </template>
        </date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import { enGB as en, arSA as ar } from 'date-fns/locale'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import BaseInputError from '../inputs/BaseInputError.vue'
export default {
  name: 'DatePickerDesktop',
  components: {
    DatePicker,
    BaseInputError
  },
  props: {
    value: {},
    minDate: {},
    maxDate: {},
    placeholder: { type: String, default: '' },
    validation: {},
    withInput: { },
    showAlways: { type: Boolean, default: false },
    defaultDateToSet: { default: null }
  },
  data () {
    return {
      masks: {
        input: 'D MMM YYYY',
        weekdays: 'WWW'
      },
      inputFocused: false,
      currentMonth: { month: null, year: null },
      showMonthOptions: false,
      showYearOptions: false,
      monthInputFocused: false,
      yearInputFocused: false
    }
  },
  computed: {
    errorInput () {
      return this.validation?.$dirty && this.validation?.$invalid
    },
    acceptInput () {
      if (!this.validation) return false
      return !this.validation?.$invalid
    },
    locale () {
      return this.$i18n.locale
    },
    formatLocale () {
      if (this.locale === 'ar') {
        return ar
      } else {
        return en
      }
    },
    show () {
      return this.showAlways || this.inputFocused
    },
    formattedValue () {
      return this.formatDate(this.value_)
    },
    value_ () {
      return this.value instanceof Date && !isNaN(this.value) ? this.value : null
    },
    date () {
      return this.value_ || (this.minDate || new Date())
    },
    minYear () {
      if (this.minDate) return this.minDate.getFullYear()
      const date = this.maxDate || new Date()
      return date.getFullYear() - 75
    },
    maxYear () {
      if (this.maxDate) return this.maxDate.getFullYear()
      return (new Date()).getFullYear() + 10
    },
    yearsList () {
      const minYear = this.minYear
      const maxYear = this.maxYear
      const years = Array.from({ length: maxYear - minYear + 1 }, (_, i) => maxYear - i)
      if (this.minDate) return years.reverse()
      return years
    },
    formatString () {
      return 'd MMMM yyyy'
    },
    yearRowHeight () {
      return this.$refs.yearInput.clientHeight
    },
    defaultDateToSet_ () {
      return this.defaultDateToSet
    }
  },
  methods: {
    onDayClick () {
      this.inputFocused = false
    },
    onInput (value) {
      this.$emit('input', value)
    },
    onUpdateToPage (page) {
      // TODO: chage month and year when user slides
      // console.log(this.currentMonth, page.year)
      // this.selectMonth(page.month - 1)
      // this.$nextTick(() => {
      //   this.selectYear(page.year)
      // })
    },
    onFocus () {
      this.inputFocused = true
    },
    getMonthName (mon) {
      const date = new Date('1990-01-01')
      date.setMonth(mon)
      return format(date, 'LLLL', { locale: this.formatLocale })
    },
    updateCalendar (oldDateInfo) {
      let day = this.value_ ? this.value_.getDate() : 1
      const maxDate = this.maxDate ||
        (this.minDate.getMonth() === this.currentMonth.month &&
          this.minDate.getFullYear() === this.currentMonth.year
          ? this.minDate
          : new Date(this.minYear))
      const minDate = this.minDate ||
        (this.maxDate.getMonth() === this.currentMonth.month &&
          this.maxDate.getFullYear() === this.currentMonth.year
          ? this.maxDate
          : new Date(this.maxYear))
      if (maxDate.getMonth() <= this.currentMonth.month &&
        maxDate.getFullYear() <= this.currentMonth.year) {
        day = maxDate.getDate()
      } else if (minDate.getMonth() >= this.currentMonth.month &&
        minDate.getFullYear() >= this.currentMonth.year) {
        day = minDate.getDate()
      }
      if (oldDateInfo !== null) this.$emit('input', new Date(this.currentMonth.year, this.currentMonth.month, day))
      return this.$refs.calendar.focusDate(new Date(this.currentMonth.year, this.currentMonth.month, day))
    },
    toggleMonth (show) {
      this.showYearOptions = false
      this.showMonthOptions = show
    },
    selectMonth (month) {
      const maxDate = this.maxDate || new Date(this.maxYear, 2, this.minDate.getDate())
      if (maxDate.getMonth() <= month &&
        maxDate.getFullYear() <= this.currentMonth.year) {
        this.currentMonth.year = maxDate.getFullYear()
        this.currentMonth.month = maxDate.getMonth()
        return
      }
      this.currentMonth.month = month
    },
    onMonthInputClick () {
      this.showMonthOptions = !this.showMonthOptions
    },
    toggleYear (show) {
      this.showMonthOptions = false
      this.showYearOptions = show
    },
    selectYear (year) {
      const maxDate = this.maxDate || new Date(this.maxYear, 2, this.minDate.getDate())
      if (maxDate.getMonth() <= this.currentMonth.month &&
        maxDate.getFullYear() <= year) {
        this.currentMonth.year = maxDate.getFullYear()
        this.currentMonth.month = maxDate.getMonth()
        return
      }
      this.currentMonth.year = year
    },
    onYearInputClick () {
      this.showYearOptions = !this.showYearOptions
      if (this.showYearOptions) this.scrollToSelectedYear()
    },
    hideCalendar () {
      this.inputFocused = false
    },
    closeCalendar ($event) {
      const el = $event.composedPath()
      const calendareBody = this.$refs.calendarWrap
      if (!el.includes(calendareBody)) {
        this.hideCalendar()
      }
    },
    scrollToSelectedYear () {
      const currentYear = this.currentMonth.year
      const arrayIndex = this.yearsList.indexOf(currentYear)
      const scrollToY = arrayIndex * (this.yearRowHeight + 1) - ((this.yearRowHeight + 1))
      this.$nextTick(() => {
        this.$refs.yearList.scrollTop = scrollToY
      })
    },
    formatDate (value) {
      const marker = this.locale === 'ar' ? '\u200f' : ''
      return value ? format(value, `${marker}${this.formatString}`, { locale: this.formatLocale }) : ''
    },
    parseDate (value) {
      const now = new Date()
      const result = parse(value, this.formatString, new Date(now.getFullYear(), now.getMonth(), now.getDate()))
      return result instanceof Date && !isNaN(result) ? result : null
    }
  },
  created () {
    const now = new Date()
    const month = this.value_?.getMonth() ?? this.defaultDateToSet?.getMonth() ?? this.maxDate?.getMonth() ?? now.getMonth()
    const year = this.value_?.getFullYear() || this.defaultDateToSet?.getFullYear() || this.maxDate?.getFullYear() || now.getFullYear()
    this.currentMonth = { month, year }
  },
  mounted () {
    if (this.value_) { this.updateCalendar() }
    document.addEventListener('click', this.closeCalendar)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeCalendar)
  },
  watch: {
    'currentMonth.month': function (_, oldValue) {
      this.updateCalendar(oldValue)
        .catch(() => {
          this.currentMonth.month = oldValue
        })
    },
    'currentMonth.year': function (_, oldValue) {
      this.updateCalendar(oldValue)
        .catch(() => {
          this.currentMonth.year = oldValue
        })
    },
    defaultDateToSet_ (newValue) {
      const now = new Date()
      const defaultDate = new Date(this.defaultDateToSet)
      const month = this.value_?.getMonth() ?? defaultDate?.getMonth() ?? this.maxDate?.getMonth() ?? now.getMonth()
      const year = this.value_?.getFullYear() || defaultDate?.getFullYear() || this.maxDate?.getFullYear() || now.getFullYear()
      this.currentMonth = { month, year }
    }
  }
}
</script>
<style lang="scss" >
  .datepicker-desktop, .selectDob, .dobDay {
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0,0,0);
    transform: translateZ(0);
  }
  .__vuescroll {
    overflow-y: auto;
    transform: translateZ(0);
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0,0,0);
    ::-webkit-scrollbar-thumb {
      display: none;
    }
    ::-webkit-scrollbar-track {
      display: none;
    }
  }
  .__bar-wrap-is-vertical {
    margin-top: 12px!important;
    margin-bottom: 12px!important;
  }
  .__bar-is-vertical{
    border-radius: 100px!important;
  }
</style>
